import React from 'react';
import Link from '../../../components/Link';
import MainContainer from '../../Main';
//import BidPersonHistory from '../../../components/PersonProfile/BidPersonHistory';
import SidebarVisits from '../../../components/PersonProfile/SidebarVisits';
import { FormattedMessage, injectIntl } from 'react-intl';
import page from 'page'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, lifecycle } from 'recompose'
import { logOut } from '../../../store/reducers/auth'
import { fetchingState } from './../../../helpers/hocs.js'
import { getIsLogged, getLoggedUser } from '../../../selectors/user.js'
import { getState, getBidHistory, paidIsDone, requestMeet } from '../../../store/reducers/profile/info'
import { get, getLots, getActiveLot, subsribe } from '../../../store/reducers/persons/info';
import { getTotalLotsSum } from '../../../selectors/person';
import Overlay from '../../../components/Overlay';
import VisitCalendar from '../../../components/VisitCalendar';
import VisitDetals from '../../../components/VisitDetals';
import { getAllVisits } from '../../../store/reducers/visitsOfPerson';
import moment from 'moment';
import ProfileWrapper from '../../../components/PersonProfile/ProfileWrapper';
import Select from '../../../components/Select'
import Messengers from '../../../components/Messengers';
import { sendFirstVisitView } from '../../../store/reducers/role'; 


//компонент аукционов для роли персоны
const Visits = ({getModalWindow, currentVisit, setCurrentVisit, intl, visits, showVisitsCalendar, setVisitsCalendar, setVisitsDetals, showVisitsDetals, user, logOut, isLogged, tab, setTab, lots, total, watchVisits}) => {
    if (!user && !user.person && !isLogged) return null

    const actualVisits = []
    const expiredVisits = []

    if (Object.keys(visits).length > 0) {
        Object.keys(visits).forEach(status => {
            if (status === 'visited' || status === 'late' || status === 'declined') {
                visits[status].forEach(visit => {
                    expiredVisits.push(visit);
                })
            } else {
                visits[status].forEach(visit => {
                    actualVisits.push(visit)
                })
            }
        })
    }

    const getNextTab = (data, type) => {
        setTab(true)
        setCurrentVisit({data: data, type: type})
        watchVisits({visitId: data._id});
    }

    const back = () => {
        setTab(false)
    }

    return ( 
        // <MainContainer
        //     Sidebar={<SidebarVisits getModalWindow={getModalWindow} visits={actualVisits}/>}
        // >
        <ProfileWrapper 
            title={`${total.sum} ₽`}
            text="собрано на благотворительных аукционах с вашим участием" 
            active="meetings" 
            switch={{status: tab, currentData: currentVisit}}
            back={back}
            user={user}
        >
            {actualVisits.length > 0  && <Select 
                required 
                items={actualVisits.length > 0  && actualVisits.map(visit => ({
                    name: moment(visit.is.created).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY'), 
                    sub: 
                        visit.status === "agreement" ? "ожидает подтверждения" 
                        : visit.status === "agreed" ? `встреча состоится ${moment(visit.date).fromNow()}`
                        : visit.status === "new" || visit.status === "old" || visit.status === "waiting"  || visit.status === "personally"  ? "ожидает согласования" : "", 
                    onClick: () => getNextTab(visit, visit.status === "agreed" ? "agreed" : "agreement")

                }))} 
                class="Select_theme_block" 
                placeholder="Новые встречи"
                sub={actualVisits.length}
            />}
            {expiredVisits.length > 0 && <Select 
                required 
                items={expiredVisits.length > 0 && expiredVisits.map(visit => ({
                    name: moment(visit.is.created).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY'), 
                    sub: `завершилась ${moment(visit.date).utc().add(3, 'hours').format('DD/MM/YYYY')}`, 
                    onClick: () => getNextTab(visit, "agreement")
                }))} 
                class="Select_theme_block" 
                placeholder="Завершенные встречи"
                sub={expiredVisits.length}
            />}
            {
               expiredVisits.length === 0 && actualVisits.length === 0  &&
               <p style={{paddingLeft: "16px", color: "#8c8c8c"}}>
                   У вас пока не было благотворительных встреч
               </p>
            }
            {/* {(visits.visited && visits.visited.length > 0) &&
                <div className='Visited visits-items'>
                    <div className='_auction-history history-title'>Прошедшие встречи</div>
                    <div className='person _auctions-history items lastVisits'>
                        {
                            visits.visited.map(visit =>
                                <div key={visit._id} className='Main__founds-item Orange lastVisit' >
                                    <span className='Main__table-column-costName'><nobr>{`${visit.user.surname} ${visit.user.name}`}</nobr></span>
                                    <span className='Main__table-column-costName'>
                                        {visit.date ? moment(visit.date).add(3, 'hours').utc().format('DD.MM.YYYY, HH:mm') : 'без даты'}
                                    </span>
                                    <button
                                        data-id={visit._id}
                                        data-status={visit.status}
                                        data-type='details'
                                        onClick={getModalWindow} 
                                        className='Main__table-column-costName Button Button_white'
                                    >
                                        Подробнее
                                    </button>
                                </div>
                            )
                        }
                    </div>
                </div>
            }
            {(visits.late && visits.late.length > 0) &&
                <div className='Late visits-items'>
                    <div className='_auction-history history-title'>Просроченные встречи</div>
                    <div className='person _auctions-history items lastVisits'>
                        {
                            visits.late.map(visit =>
                                <div key={visit._id} className='Main__founds-item Orange lastVisit' >
                                    <span className='Main__table-column-costName'><nobr>{visit.user}</nobr></span>
                                    <span className='Main__table-column-costName'>
                                        {visit.date ? moment(visit.date).add(3, 'hours').utc().format('DD.MM.YYYY, HH:mm') : 'без даты'}
                                    </span>
                                    <button
                                        data-id={visit._id}
                                        data-status={visit.status}
                                        data-type='details'
                                        onClick={getModalWindow}
                                        className='Main__table-column-costName Button Button_white'
                                    >
                                        Подробнее
                                    </button>
                                </div>
                            )
                        }
                    </div>
                </div>
            } */}
            <Overlay isActive={showVisitsCalendar} onClose={()=> setVisitsCalendar(false)} klassModifier={"mfc-modal_3"}>
                <VisitCalendar visit={currentVisit} role={user.role} personId={user.person._id} />
            </Overlay>
            <Overlay isActive={showVisitsDetals} onClose={()=> setVisitsDetals(false)} klassModifier={"mfc-modal_3"}>
                <VisitDetals visit={currentVisit} />
            </Overlay>
        </ProfileWrapper>
        // {/* </MainContainer> */}
    )
}

const mapStateToProps = state => ({
    isLogged: getIsLogged(state),
    total: getTotalLotsSum(state),
    visits: {...state.visitsOfPerson.items}
})
  
const mapDispatchToProps = dispatch => bindActionCreators({ get, getLots, getAllVisits, getState, getBidHistory, getActiveLot, logOut, paidIsDone, requestMeet, sendFirstVisitView }, dispatch)
const mergeProps = (state, {get, getLots, getActiveLot, requestMeet, getAllVisits, logOut, sendFirstVisitView, ...dispatch }, props) => ({
    ...props,
    ...state,
    logOut,
    get: async (id) => {
        let memberId = id || props.user.person._id;
        let result = await props.fetchingWrap(get.bind(this, memberId), 'info')
        if (result === 200) {
            //получаем список встреч персоны
            await getAllVisits()
            await getLots(memberId)
        } else props.on404()
    },
    sendVisitView: (visitId) => {
        return(props.fetchingWrap(sendFirstVisitView.bind(this, visitId), 'send'))
    }
})
  
export default injectIntl(compose(
    fetchingState({ multi: true }),
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    withState('currentVisit', 'setCurrentVisit', {}),//текущая выбранная встреча
    withState('showVisitsCalendar', 'setVisitsCalendar', false),// показать/скрыть календарь выбора даты встречи
    withState('showVisitsDetals', 'setVisitsDetals', false),// показать/скрыть всплывающее окно деталей встречи
    withState("tab", "setTab", false),
    withHandlers({
        getModalWindow: ({setCurrentVisit, setVisitsDetals, setVisitsCalendar, visits}) => e => {//при клике на кнопки Подробнее/Назначить
            e && e.preventDefault()
            const id = e.target.dataset.id
            const status = e.target.dataset.status
            const newCurrentVisit = visits[status].filter(visit => visit._id === id)[0]
            setCurrentVisit(newCurrentVisit)

            //в зависимости от типа кнопки показываем окно подробности или календарь
            switch (e.target.dataset.type) {
                case 'details':
                    setVisitsDetals(true)
                    break;
                case 'calendar':
                    setVisitsCalendar(true)
                    break;
                default:
                    return
            }
        },
        watchVisits: ({sendVisitView}) => async (visit, e) => {
            const result = await sendVisitView(visit.visitId);
          }
    }),
    lifecycle({
        componentWillUnmount () {
            this.props.setCurrentVisit(null)
        },
        componentWillMount () {
            if (!this.props.isLogged) this.props.on404()
            else {
                this.props.get()
            }
        },
        componentWillReceiveProps (np) {
            if (this.props.isLogged && !np.isLogged) page('/')
            if ((np.user && np.user.person) && (np.user.person._id !== this.props.user.person._id)) {
                this.props.get(np.user.person._id)
            }
        }
    })
)(Visits))


// WEBPACK FOOTER //
// ./src/containers/roles/person/Visits.jsx